import type { PaymentState, PaymentStatus } from '../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../formCheckClasses'

interface Props {
  isView: boolean
  payment: PaymentState
  updatePayment: (patch: Partial<PaymentState>) => void
}

const FinanceSection: React.FC<Props> = ({ isView, payment, updatePayment }) => {
  const setStatus = (status: PaymentStatus) => {
    updatePayment({ status })
  }

  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>ด้านการเงิน</div>
        </div>
        <div className='card-body'>
          <p className='text-gray-700 mb-4'>การชำระเงินค่าเสา</p>

          <div className='d-flex flex-column gap-4'>
            <div className={wonFormCheckRow}>
              <input
                className={wonFormCheckInput}
                type='radio'
                name='won-payment-status'
                id='won-payment-completed'
                checked={payment.status === 'completed'}
                disabled={isView}
                onChange={() => setStatus('completed')}
              />
              <label className={wonFormCheckLabel} htmlFor='won-payment-completed'>
                เรียบร้อย
              </label>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-payment-status'
                  id='won-payment-deposit'
                  checked={payment.status === 'deposit'}
                  disabled={isView}
                  onChange={() => setStatus('deposit')}
                />
                <label className={wonFormCheckLabel} htmlFor='won-payment-deposit'>
                  รับมัดจำ
                </label>
              </div>
              <input
                type='text'
                inputMode='decimal'
                className='form-control form-control-sm text-end'
                style={{ width: 72 }}
                value={payment.depositPercent}
                disabled={isView || payment.status !== 'deposit'}
                onChange={e => updatePayment({ depositPercent: e.target.value })}
              />
              <span className='align-self-center'>%</span>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-payment-status'
                  id='won-payment-promissory'
                  checked={payment.status === 'promissory'}
                  disabled={isView}
                  onChange={() => setStatus('promissory')}
                />
                <label className={wonFormCheckLabel} htmlFor='won-payment-promissory'>
                  ตั๋วค่าเสา
                </label>
              </div>
              <input
                type='text'
                inputMode='numeric'
                className='form-control form-control-sm'
                style={{ width: 88 }}
                value={payment.promissoryDays}
                disabled={isView || payment.status !== 'promissory'}
                onChange={e => updatePayment({ promissoryDays: e.target.value })}
              />
              <span className='align-self-center'>วัน</span>
            </div>

            <div>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-payment-status'
                  id='won-payment-not-completed'
                  checked={payment.status === 'not_completed'}
                  disabled={isView}
                  onChange={() => setStatus('not_completed')}
                />
                <label className={wonFormCheckLabel} htmlFor='won-payment-not-completed'>
                  ไม่เรียบร้อย
                </label>
              </div>
              <textarea
                className='form-control form-control-sm mt-2'
                rows={3}
                placeholder='เหตุผล'
                value={payment.notCompletedReason}
                disabled={isView || payment.status !== 'not_completed'}
                onChange={e => updatePayment({ notCompletedReason: e.target.value })}
              />
            </div>

            <div className={wonFormCheckRow}>
              <input
                className={wonFormCheckInput}
                type='radio'
                name='won-payment-status'
                id='won-payment-cheque'
                checked={payment.status === 'cheque'}
                disabled={isView}
                onChange={() => setStatus('cheque')}
              />
              <label className={wonFormCheckLabel} htmlFor='won-payment-cheque'>
                เช็ค
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinanceSection
